
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation/final",
      function () {
        return require("private-next-pages/bcks/invitation/final.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation/final"])
      });
    }
  